import { config } from "@/config";

import { useCookie } from "./use-cookie";

const usePageSizeCookie = () => useCookie("pageSize", config.dataMasterPageSizeOptions[2], Number);

export { usePageSizeCookie };
